import * as api from '../../requests'

export const setWorkItemId = (id) => (dispatch) => {
  dispatch({
    type: 'SET_WORKITEM_ID',
    id
  })
}

export const setDrawerShown = (setDrawerShown) => (dispatch) => {
  dispatch({
    type: 'SET_DRAWER_SHOWN',
    setDrawerShown
  })
}

export const fetchAndSetWorkviewItemHistory = (id, callback) => (dispatch) =>{
  api.GET_WORKVIEW_ITEM_HISTORY(
    id,
    (data, props = {}) => {
      dispatch(setWorkviewItemHistory)
      if(callback) callback(data)
    },
    (err) => {
      dispatch(setHistorySidebarError(true))
      dispatch(setHistorySidebarErrorDetails({ message: err.Message, code: err.Code }))
    }
  )
}

export const setWorkviewItemHistory = (history) => ({
  type: 'SET_WORKVIEW_ITEM_HISTORY',
  history
})

export const setHistorySidebarError = (error) => ({  
  type: 'SET_WORKVIEW_ERROR',
  error
})

export const setHistorySidebarErrorDetails = (errorDetails) => ({
  type: 'SET_WORKVIEW_ERROR_DETAILS',
  errorDetails,
})